import { render } from "./Lightbox.vue?vue&type=template&id=3da61a5a&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"

import "./Lightbox.vue?vue&type=style&index=0&id=3da61a5a&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da61a5a"]])

export default __exports__